import { useEffect, useState } from 'react';
const useMousePosition = (target) => {
    const [mousePosition, setMousePosition] = useState({ x: null, y: null });
    const [mouseStatus, setMouseStatus] = useState('OUTSIDE');
    // let focusTimeout: number;
    const updateMousePosition = (e) => {
        setMousePosition({ x: e.offsetX, y: e.offsetY });
    };
    const updateMouseOver = (e) => {
        // console.log('mouse over');
        // console.log(e.type);
        // clearTimeout(focusTimeout);
        setMouseStatus('OVER');
    };
    const updateMouseOut = (e) => {
        // console.log('mouse out');
        // console.log(e.type);
        // focusTimeout = setTimeout(() => {
        setMouseStatus('OUTSIDE');
        // }, 50);
    };
    useEffect(() => {
        target === null || target === void 0 ? void 0 : target.current.addEventListener('mousemove', updateMousePosition);
        target === null || target === void 0 ? void 0 : target.current.addEventListener('focusin', updateMouseOver);
        target === null || target === void 0 ? void 0 : target.current.addEventListener('focusout', updateMouseOut);
        target === null || target === void 0 ? void 0 : target.current.addEventListener('mouseenter', updateMouseOver);
        target === null || target === void 0 ? void 0 : target.current.addEventListener('mouseleave', updateMouseOut);
        return () => {
            target === null || target === void 0 ? void 0 : target.current.removeEventListener('mousemove', updateMousePosition);
            target === null || target === void 0 ? void 0 : target.current.removeEventListener('focusin', updateMouseOver);
            target === null || target === void 0 ? void 0 : target.current.removeEventListener('focusout', updateMouseOut);
            target === null || target === void 0 ? void 0 : target.current.removeEventListener('mouseenter', updateMouseOver);
            target === null || target === void 0 ? void 0 : target.current.removeEventListener('mouseleave', updateMouseOut);
        };
    }, []);
    return { position: mousePosition, status: mouseStatus };
};
export const handleTileNavigation = (target) => {
    const [status, setStatus] = useState('OUT');
    const [navigation, setNavigation] = useState();
    const updateNavigation = (type) => {
        setNavigation(type == 'focusin' || type == 'focusout' ? 'keyboard' : 'mouse');
    };
    const handleEnter = (e) => {
        updateNavigation(e.type);
        if (status != 'IN' && e.relatedTarget) {
            setStatus('IN');
        }
    };
    const handleExit = (e) => {
        var _a;
        updateNavigation(e.type);
        if (e.type == 'focusout') {
            if (e.relatedTarget && !((_a = target.current) === null || _a === void 0 ? void 0 : _a.contains(e.relatedTarget))) {
                setStatus('OUT');
            }
        }
        else {
            setStatus('OUT');
        }
    };
    useEffect(() => {
        target === null || target === void 0 ? void 0 : target.current.addEventListener('focusin', handleEnter);
        target === null || target === void 0 ? void 0 : target.current.addEventListener('focusout', handleExit);
        target === null || target === void 0 ? void 0 : target.current.addEventListener('mouseenter', handleEnter);
        target === null || target === void 0 ? void 0 : target.current.addEventListener('mouseleave', handleExit);
        return () => {
            var _a, _b, _c, _d;
            (_a = target === null || target === void 0 ? void 0 : target.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('focusin', handleEnter);
            (_b = target === null || target === void 0 ? void 0 : target.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('focusout', handleExit);
            (_c = target === null || target === void 0 ? void 0 : target.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('mouseenter', handleEnter);
            (_d = target === null || target === void 0 ? void 0 : target.current) === null || _d === void 0 ? void 0 : _d.removeEventListener('mouseleave', handleExit);
        };
    }, []);
    return { navigation, status };
};
export default useMousePosition;
